import { Box, Heading, Text, Link } from "@chakra-ui/layout"
import { Flex } from "@chakra-ui/react"
import { RoundButton } from "../button/Button"
import { colors } from "../colors"
import { Image } from "../image"

export function FactCTA({
  factValue,
  factDescription,
  factBackgroundColor,
  factImage,
  ctaLabel,
  ctaLink,
  ctaColor,
}) {
  return (
    <Box
      maxW="1440px"
      m="0 auto"
      p="30px 0"
      pb={{ base: `30px`, sm: `30px`, md: `250px`, lg: `100px`, xl: `30px` }}
      position="relative"
    >
      <Flex display="flex" flexWrap={{ base: `wrap`, md: `nowrap` }}>
        <Box width={{ base: `100%`, md: "50%" }}>
          {factImage?.localFile?.childImageSharp && (
            <Image image={factImage.localFile.childImageSharp} />
          )}
        </Box>
        <Box
          width={{ base: `100%`, md: "55%" }}
          position={{ base: `initial`, md: "absolute" }}
          right="0"
        >
          <Box
            backgroundColor={factBackgroundColor}
            padding={{ base: `48px 20px 0`, md: "90px" }}
          >
            <Heading
              color={"white"}
              fontSize={{ base: `60px`, md: "100px" }}
              lineHeight={{ base: `25px`, md: "50px" }}
              fontWeight="700"
              mb="20px"
            >
              {factValue}
            </Heading>

            <Text
              fontWeight="700"
              fontSize="24px"
              lineHeight="32px"
              color="white"
              textTransform="uppercase"
              fontFamily="heading"
            >
              {factDescription}
            </Text>
          </Box>
          <Box bg={{ base: factBackgroundColor, md: `transparent` }}>
            <Box
              maxW="300px"
              p={{ base: `30px 0 48px`, md: 0 }}
              mt={{ base: 0, md: "53px" }}
              ml={{ base: "auto", md: "10%" }}
              mr={{ base: "auto", md: "0" }}
              pl={{ base: "0", md: "25px" }}
            >
              <Link
                href={ctaLink}
                textDecoration="none"
                target="_blank"
                _hover={{ textDecoration: `none` }}
              >
                <RoundButton
                  backgroundColor={ctaColor}
                  color={factBackgroundColor}
                  _hover={{
                    backgroundColor: colors.purple,
                    color: colors.lime,
                  }}
                  fontSize="20px"
                  _focus={{ backgroundColor: colors.lightBlue }}
                >
                  {ctaLabel}
                </RoundButton>
              </Link>
            </Box>
          </Box>
        </Box>
      </Flex>
    </Box>
  )
}
